import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PushCompleteTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { PublishStatus } from 'types/message'

const PushComplete: FC = () => {
  const search = useSelector((state: State) => state.router.location.search)
  const publishStatus = search.split('?publishStatus=')[1] as PublishStatus

  return (
    <Layout title={'プッシュ通知設定の予約完了'}>
      <PushCompleteTemplate publishStatus={publishStatus} />
    </Layout>
  )
}

export default PushComplete
